import { render, staticRenderFns } from "./hub.vue?vue&type=template&id=2fb9bee3&scoped=true"
import script from "./hub.vue?vue&type=script&lang=js"
export * from "./hub.vue?vue&type=script&lang=js"
import style0 from "./hub.vue?vue&type=style&index=0&id=2fb9bee3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb9bee3",
  null
  
)

export default component.exports